import { SVGProps } from "react";

const FloatLogo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 954.1 367.1"
      focusable="false"
      {...props}
    >
      <path
        d="M858.4,67.2h-55.2c-1,0-1.8,0.6-2.1,1.5L784.8,122c-0.3,0.9-1.1,1.5-2.1,1.5h-34.5c-1,0-1.8,0.6-2.1,1.5l-4.7,15.2
		c-0.5,1.8-2.9,2.1-3.9,0.5c-9.4-14.6-33.5-24.1-83.4-24.1c-48,0-100.4,6.2-125.3,59.4c-0.7,1.4,0.4,3.1,2,3.1h53.2
		c0.7,0,1.4-0.4,1.8-1c15.9-24.2,29.7-26.2,54.8-26.2c34.6,0,44.7,7.1,40.2,21.7c-4.5,14.6-11.5,17.7-30.2,19l-64.8,4.4
		c-20.4,1.3-42.4,4.8-60.2,15.1c-1.4,0.8-3.2-0.2-3.2-1.8c-2.2-65.2-49.8-93.1-120.1-93.1c-54,0-94.6,16.4-111.5,53.6
		c-1,2.1-4.1,1.5-4.1-0.9V61.9c0-1.2-1-2.2-2.2-2.2H146.4c-27,0-48.8,21.9-48.8,48.8v15.7h-0.1H61.9c-1.2,0-2.2,1-2.2,2.2v35.7
		c0,1.2,1,2.2,2.2,2.2h33.3c1.2,0,2.2,1,2.2,2.2V304c0,1.2,1,2.2,2.2,2.2H155c1.2,0,2.2-1,2.2-2.2V166.4c0-1.2,1-2.2,2.2-2.2h43.5
		c1.2,0,2.2-1,2.2-2.2v-35.7c0-1.2-1-2.2-2.2-2.2h-43.5c-1.2,0-2.2-1-2.2-2.2v-13.4c0-6.4,5.2-11.6,11.6-11.6h56.1
		c1.2,0,2.2,1,2.2,2.2V304c0,1.2,1,2.2,2.2,2.2h55.4c1.2,0,2.2-1,2.2-2.2v-43.8c0-2.3,3.2-3,4.1-0.9c16.9,37.2,57.5,53.6,111.5,53.6
		c37,0,67.7-7.7,88.8-24.5c1-0.8,2.6-0.5,3.2,0.7c8.9,15.6,31.3,21.8,61.7,21.8c25.4,0,62.4-4,88.8-21.7c1.5-1,3.6,0.3,3.3,2.1
		c-0.6,4-0.8,8-0.8,11.9c0,1.2,1,2.2,2.2,2.2h55.2c1.3,0,2.3-1.1,2.2-2.4c-0.8-8.8,0.2-19.7,4.7-34.3l27.6-90.3
		c1.4-4.5,2.4-8.9,2.9-13.1c0.1-1.1,1.1-1.9,2.1-1.9h24.9c1.5,0,2.5,1.4,2.1,2.8L744,255.6c-10.1,32.9-11.1,54,45.6,54
		c12.7,0,34.5-1.9,46.5-3.2c0.9-0.1,1.6-0.7,1.8-1.5l10.9-35.7c0.4-1.5-0.7-2.9-2.2-2.8c-8.6,0.6-17.1,1.1-26.5,1.1
		c-15.6,0-18.6-4.8-14.2-19l25.5-83.3c0.3-0.9,1.1-1.5,2.1-1.5h45c1,0,1.8-0.6,2.1-1.5l10.9-35.7c0.4-1.4-0.6-2.8-2.1-2.8H847
		c-1.5,0-2.5-1.4-2.1-2.8L860.4,70C860.9,68.6,859.8,67.2,858.4,67.2z M402.4,270.8c-37,0-58.4-20-58.4-55.7
		c0-35.6,21.4-55.7,58.4-55.7c37,0,58.4,20,58.4,55.7C460.8,250.8,439.4,270.8,402.4,270.8z M665.3,231.8
		c-9.3,30.5-47.4,45.1-77.6,45.1c-22.4,0-34.9-9.2-29.9-25.5c5-16.3,17.3-22.1,38.8-23.8l35.6-3.1c10.9-0.9,22.1-2.1,33.6-6.2
		c1.7-0.6,3.3,0.9,2.8,2.7L665.3,231.8z"
      />
      <path
        d="M923.4,63.4c-16.9,0-30.6,13.8-30.6,30.8c0,17.1,13.8,31,30.6,31c16.9,0,30.6-13.8,30.6-31
		C954.1,77.2,940.3,63.4,923.4,63.4z M923.4,121.2c-14.6,0-26.4-12.1-26.4-27c0-14.9,11.8-26.9,26.4-26.9
		c14.5,0,26.4,12.2,26.4,26.9C949.8,109.1,937.9,121.2,923.4,121.2z"
      />
      <path
        d="M929.6,95.9L929.6,95.9c4.5-1,7.5-3.9,7.5-8.5c0-5.7-5-9.2-11.7-9.2h-11.2c-1.2,0-2.2,1-2.2,2.2V108c0,1.2,1,2.2,2.2,2.2
		l0,0c1.2,0,2.2-1,2.2-2.2v-8.2c0-1.2,1-2.2,2.2-2.2h4.7c4.6,0,6.1,0.9,7.7,6.5l1.5,4.6c0.3,0.9,1.1,1.5,2.1,1.5h0
		c1.5,0,2.5-1.4,2.1-2.8l-1.1-3.3C934.2,99.5,932.7,97.1,929.6,95.9z M924.9,93.9h-6.4c-1.2,0-2.2-1-2.2-2.2v-7.6
		c0-1.2,1-2.2,2.2-2.2h6.7c4.4,0,7.4,2.3,7.4,6.1C932.6,91.6,930.1,93.9,924.9,93.9z"
      />
    </svg>
  );
};

export default FloatLogo;
